import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Services
import { NavigationParam, RouteParam, ServiceBase } from '../service-base';

// Modèles
import { Conversation } from 'src/app/@shared/models/messaging/conversation.model';

const CLASS_NAME = 'Conversation';
const ENDPOINT = `/conversations/`;

const ROUTES: RouteParam[] = [
    { key: 'follow', path: '{id}/follow/' },
    { key: 'unfollow', path: '{id}/unfollow/' },
]

const NAVIGATIONS: NavigationParam[] = [
    { key: 'items', path: 'items/', childClass: 'ConversationItem' },
]


@Injectable({
    providedIn: 'root'
})
export class ConversationService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addRoutes(ROUTES);
        this.addNavigations(NAVIGATIONS);
    }

    public follow$(conversation: Conversation): Observable<Conversation> {
        let url = this.routes.follow.replace('{id}', conversation.id.toString());
        return this.update$(conversation, {
            url: url,
            showMessages: false,
        });
    }

    public unfollow$(conversation: Conversation): Observable<Conversation> {
        let url = this.routes.unfollow.replace('{id}', conversation.id.toString());
        return this.update$(conversation, {
            url: url,
            showMessages: false,
        });
    }
}
